"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const __1 = require("../../..");
const styles_1 = require("./styles");
const fa_1 = require("react-icons/fa");
const HeaderInfo_1 = require("./HeaderInfo");
const AdminButton_1 = require("./AdminButton");
class Header extends react_1.default.Component {
    constructor() {
        // renderTitle = () => {
        //   if (this.props.title) {
        //     return <PageTitle>{this.props.title}</PageTitle>;
        //   } else {
        //     var routeName = this.props.history.location.pathname;
        super(...arguments);
        //     for (let route of this.props.routes) {
        //       if (
        //         routeName === route.path ||
        //         routeName === route.linkPath ||
        //         routeName.includes(route.linkPath)
        //       ) {
        //         return <PageTitle>{route.title}</PageTitle>;
        //       }
        //     }
        //     return null;
        //   }
        // };
        this.renderTitle = () => {
            if (this.props.title) {
                return this.props.title;
            }
            else {
                var routeName = this.props.history.location.pathname;
                for (let route of this.props.routes) {
                    if (routeName === route.path ||
                        routeName === route.linkPath ||
                        routeName.includes(route.linkPath)) {
                        return route.title;
                    }
                }
                return null;
            }
        };
        this.toggleMenu = async () => {
            await this.props.toggleMenu();
        };
    }
    render() {
        return (react_1.default.createElement(styles_1.PageHeader, null,
            react_1.default.createElement(styles_1.MenuButtonContainer, { className: "col-2" },
                react_1.default.createElement(styles_1.MenuButton, { className: "btn btn-link", onClick: this.toggleMenu },
                    react_1.default.createElement(fa_1.FaBars, null))),
            react_1.default.createElement(styles_1.PageNames, null,
                react_1.default.createElement(styles_1.PageTitle, null, this.renderTitle()),
                react_1.default.createElement(styles_1.PageUser, { className: "text-right" },
                    react_1.default.createElement(__1.Row, null,
                        react_1.default.createElement(__1.Col, null,
                            this.props.username,
                            react_1.default.createElement(AdminButton_1.AdminButton, { admin: this.props.admin }))))),
            react_1.default.createElement(HeaderInfo_1.HeaderInfo, { title: this.renderTitle(), username: this.props.username, admin: this.props.admin })));
    }
}
exports.Header = Header;
